<template>
  <div class="auth-block">
    <div class="auth-screen">
      <div class="auth-screen__top">
        <div class="auth-screen__top__image-block">
          <img
            class="auth-screen__top__image-block__image"
            src="@/assets/logo.png"
            alt="Sollers Ford SVO"
            width="220"
            height="66"
          >
        </div>
        <div class="auth-screen__top__info-block">
          <span class="auth-screen__top__info-block__text">система для оформления <br> заказов с опциями</span>
        </div>
      </div>
      <div class="lost-block">
        <div
          v-if="isEmailVerified === null && processing && !user"
          class="alert alert-info py-4 d-flex align-items-center justify-content-center"
        >
          <b class="mr-2">Пожалуйста, подождите...</b>
          <b-spinner type="grow" />
        </div>
        <div
          v-else-if="isEmailVerified && user"
          class="alert alert-info pt-4 pb-4 text-center"
        >
          <b>Пользователь: {{ user.email }}</b><br>
          <b>E-mail адрес успешно подтвержден!</b>
        </div>
        <div
          v-else-if="isEmailVerified === false"
          class="alert alert-warning"
        >
          Не удалось подтвердить e-mail. Повторите попытку позже или обратитесь к администратору.
        </div>
      </div>
      <div
        v-if="isEmailVerified !== false"
        class="auth-screen__middle"
      >
        <form
          class="auth-form"
          @submit.prevent="changePassword"
        >
          <b-form-group label="Пожалуйста, придумайте новый пароль">
            <b-form-input
              id="password"
              v-model="password"
              type="password"
              autocomplete="new-password"
              :state="validation.password.state"
            >
            </b-form-input>
            <b-form-invalid-feedback id="password-feedback">
              {{ validation.password.error }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Подтвердите пароль">
            <b-form-input
              id="confirm-password"
              v-model="confirmPassword"
              type="password"
              autocomplete="new-password"
              :state="validation.confirmPassword.state"
            >
            </b-form-input>
            <b-form-invalid-feedback id="confirm-password-feedback">
              {{ validation.confirmPassword.error }}
            </b-form-invalid-feedback>
          </b-form-group>
          <div class="auth-form__button mt-4">
            <button
              type="submit"
              class="btn btn-primary btn-block"
              :disabled="!isEmailVerified || processing"
            >
              Сохранить
            </button>
          </div>
        </form>
      </div>
    </div>
    <warning />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Warning from '@/components/sign-in/AuthWarning.vue';

export default {
  name: 'EmailVerification',

  components: {
    Warning,
  },

  props: {
    verificationCode: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    isEmailVerified: null,
    processing: false,
    password: '',
    confirmPassword: '',
    validation: {
      password: { error: '', state: null },
      confirmPassword: { error: '', state: null },
    },
  }),

  computed: {
    ...mapState(['user']),
  },

  created() {
    this.$store.commit('logOut');
    setTimeout(() => {
      this.verifyEmail();
    }, 100);
  },

  methods: {
    async verifyEmail() {
      this.processing = true;

      try {
        await this.$http.post('users/1.0/token-validate', {
          token: this.verificationCode,
        });
        this.isEmailVerified = true;
      } catch (error) {
        this.isEmailVerified = false;
      } finally {
        this.processing = false;
      }
    },
    validateForm() {
      Object.assign(this.$data.validation, this.$options.data().validation);

      let isFormValid = true;

      if (this.password && this.password.length < 12) {
        this.validation.password.error = 'Длина пароля менее 12 символов';
        this.validation.password.state = false;
        isFormValid = false;
      }

      if (!this.password) {
        this.validation.password.error = 'Необходимо заполнить поле';
        this.validation.password.state = false;
        isFormValid = false;
      }

      if (!this.confirmPassword) {
        this.validation.confirmPassword.error = 'Необходимо заполнить поле';
        this.validation.confirmPassword.state = false;
        isFormValid = false;
      }

      if (this.password !== this.confirmPassword) {
        this.validation.confirmPassword.error = 'Пароль и подтверждение не совпадают';
        this.validation.confirmPassword.state = false;
        isFormValid = false;
      }

      return isFormValid;
    },
    async changePassword() {
      if (this.validateForm()) {
        this.processing = true;
        try {
          await this.$http.post('users/1.0/set-password', {
            password: this.password,
          });
          this.$router.push('/user-list');
        } finally {
          this.processing = false;
        }
      }
    },
  },
};
</script>
